import { createInstance as createI18Next } from 'i18next';

class Translator {
	
	constructor(options) {
		const { id, defaultLocale, locale, dependencies, translations } = options
		
		const instance = createI18Next({
			lng: locale,
			debug: process.env.DEVELOPMENT_BUILD || false,
			fallbackLng: defaultLocale,
			defaultNS: id,
			resources: translations,
			fallbackNS: dependencies,
			interpolation: {
				prefix: '{',
				suffix: '}'
			}
		});
						
		instance.init();
				
		this.delegate = instance;
		this.id = id;
		this.translations = translations;
	}
	
	addLocale(locale, identifier, translation) {
		this.delegate.addResourceBundle(locale, identifier, translation, true, true);
	}
	
	changeLanguage(language) {
		return this.delegate.changeLanguage(language);
	}
	
	translate(keyOptions) {
		const { key, count, args } = keyOptions;

		// we use indexed arguments instead of named for now..
		const options = {
			count: count
		};

		for( let i = 0; i < args.length; i++) {
			options[i] = args[i];
		}

		return this.delegate.t(key, options);
	}

	exists(key) {
		return this.delegate.exists(key);
	}
	
	search(pattern, maxSize) {
		return Object.keys(this.translation)
			.filter(key => key.toLowerCase().indexOf(pattern) >= 0);
	}
	
}

export {
	Translator
}
